import styled from "styled-components";
import { H3 } from "../../common";

export const CaptionBox = styled(H3)`
  padding: 20px 0 0 20px;
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;
